import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DoneIcon from '@mui/icons-material/Done';
import {useReduxReducer} from "../../../redux/store";

interface PayAtAgencyButtonProps {
  bookingKey?: string;
}
const PayAtAgencyButton: React.FC<PayAtAgencyButtonProps> = ({ bookingKey }) => {
  const {t} = useTranslation()
  const { aboutUs } = useReduxReducer(state => state.config)
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const getFullAddress = () => {
    if (!aboutUs) return '';
    const { street, houseNumber, zip, city, country } = aboutUs;
    return `${street}${houseNumber ? ` ${houseNumber}` : ''}, ${zip} ${city}, ${country}`;
  };

  return (
    <>
      <Button
        variant='outlined'
        onClick={handleOpen}
        className="bg-primary-6000 text-primary-6000 hover:bg-primary-700"
      >
{t("b2c.booking.payatagency")}
      </Button>

      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>{t("pdf.information")}</DialogTitle>
        <DialogContent>
          <div className="space-y-3 py-2">
            <h3 className="font-bold text-lg">{aboutUs?.agencyName}</h3>
            <p>{getFullAddress()}</p>
            <p>
              {aboutUs?.phone && <div>{t("generals.phone")}: {aboutUs.phone}</div>}
              {aboutUs?.email && <div>{t("generals.email")}: {aboutUs.email}</div>}
            </p>
            
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{t("flights.close")}</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PayAtAgencyButton; 